"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiPaginationProps = void 0;
exports.MuiPaginationProps = {
    color: 'primary',
};
